import React from 'react';
import ListarDatos from '../general/ListarDatos';
import { Popover } from '@material-ui/core';

export default function AcompanamientoNotificaciones({ render, horizontal = 'right', cargando = false, notificaciones }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      {render(handleClick)}
      <Popover
        id={id}
        open={open}
        className='notificaciones_estudiantes'
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <ListarDatos
          datos={notificaciones}
          id='tbl_estudiantes_reportados'
          titulo='Estudiantes Reportados'
          cargando={cargando}
          opciones={true}
          buscar={true}
          avatarImg={false}
          avatar={({ estudiante_acompanamiento }) => estudiante_acompanamiento.primer_nombre.charAt(0).toUpperCase()}
          color_avatar={() => ({ backgroundColor: '#B70E0C', color: 'white' })}
          fila_principal={({ estudiante_acompanamiento }) => 
            `${estudiante_acompanamiento.primer_nombre} ${estudiante_acompanamiento.primer_apellido}`
          }
          filas={[
            { 'id': 'programa', 'nombre': 'Programa:', 'mostrar': ({ programa }) => programa?.nombre || 'N/A' },
            { 'id': 'asignatura', 'nombre': 'Asignatura:', 'mostrar': ({ asignatura }) => asignatura || 'N/A' },
            { 'id': 'docente_reporta', 'nombre': 'Docente Reporta:', 'mostrar': ({ docente_reporta }) => `${docente_reporta.primer_nombre} ${docente_reporta.primer_apellido}` },
          ]}
        />
      </Popover>
    </>
  );
}